import React from 'react';
import { UseFormReturn } from 'react-hook-form';
import RequestFormPageState from '@components/RequestForm/RequestFormPage.types';
import { useHistory } from 'react-router-dom';
import { SurgeryProcedureInterface } from '@components/RequestForm/SurgeryInformation/SurgeryInformationInterface';

/***
 * useSetPrimaryProcedureNameAndSurgeon(): void
 * populates the surgeon when coming from Scheduling page
 * populates the surgeon and procedure name when coming from Find a Time page
 * @param formMethods {UseFormReturn<SurgeryProcedureInterface>} - formMethods from useForm setup
 *
 * @returns (value: number) => {void}
 */
export const useSetPrimaryProcedureNameAndSurgeon = (formMethods: UseFormReturn<SurgeryProcedureInterface>) => {
	const { location: { state } } = useHistory<RequestFormPageState>();

	return React.useCallback((value: number) => {
		// only set surgeon and procedure name for primary procedure (equals 1)
		if (value !== 1) { return; }

		const surgeonValue = formMethods.getValues().surgeon;
		if (state?.blockInfo?.surgeon?.id && !surgeonValue) {
			formMethods.setValue('surgeon', state.blockInfo.surgeon.id, { shouldValidate: false });
		}
		if (state?.findATimeRequestFormValues?.primarySurgeon && !surgeonValue) {
			formMethods.setValue('surgeon', state.findATimeRequestFormValues.primarySurgeon, { shouldValidate: false });
		}
		const procedureNameValue = formMethods.getValues().procedureName;
		if (state?.findATimeRequestFormValues?.procedureName && !procedureNameValue) {
			formMethods.setValue('procedureName', state.findATimeRequestFormValues.procedureName);
		}
	}, [formMethods, state?.blockInfo?.surgeon?.id, state?.findATimeRequestFormValues?.primarySurgeon, state?.findATimeRequestFormValues?.procedureName]);
};
